(() => {
  const ready = (fn) => { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true }); else fn(); };

  const parseCsvNums = (csv = '') => csv.split(',').map(s => parseInt(String(s).trim(), 10)).filter(Boolean);

  const findHost = () => document.querySelector('#mini-cart-form, .cart__recap, [data-enable-conditional-atc-item="true"]');

  const getDrawer = () => document.getElementById('mini-cart');

  const isCartPage = () => {
    try { return /^\/cart(?:\/|$)/.test(location.pathname || ''); } catch (e) { return false; }
  };

  const isDrawerOpen = (drawer) => {
    if (!drawer) return false;
    if (drawer.hasAttribute('open')) return true;
    const ah = drawer.getAttribute('aria-hidden');
    if (ah === 'false') return true;
    const c = drawer.classList;
    return c.contains('open') || c.contains('is-open') || c.contains('drawer--open') || c.contains('mini-cart--open');
  };

  const headersJson = { 'Content-Type': 'application/json' };

  let syncing = false;
  let lastCart = null;
  let lastTs = 0;
  let lastReq = null;

  const fetchCart = (force) => {
    const now = Date.now();
    if (!force && lastCart && (now - lastTs) < 1500) return Promise.resolve(lastCart);
    if (!force && lastReq) return lastReq;
    lastReq = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(c => { lastCart = c; lastTs = Date.now(); lastReq = null; return c; })
      .catch(e => { lastReq = null; throw e; });
    return lastReq;
  };

  const dispatchTheme = (cart) => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
  };

  const viewForRules = (cart, giftIds) => {
    const nonGift = cart.items.filter(i => !giftIds.includes(i.variant_id));
    const count = nonGift.reduce((s, i) => s + i.quantity, 0);
    (void 0);
    return { count, subtotal: cart.items_subtotal_price / 100, total: cart.total_price / 100 };
  };

  const violatesProductRule = (cart, productList, useAsExclusion) => {
    if (!productList.length) return false;
    const present = cart.items.some(i => productList.includes(i.product_id));
    return useAsExclusion ? present : !present;
  };

  const schedule = (fn) => {
    const run = () => { try { fn(); } catch (e) {} };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 0);
  };

  function boot() {
    const host = findHost();
    if (!host) return;

    const enabled = (host.dataset.enableConditionalAtcItem === 'true');
    const type = host.dataset.atcItemConditionType || 'cart_total';
    const threshold = parseFloat(host.dataset.atcItemThresholdValue || '0');
    const gifts = parseCsvNums(host.dataset.atcItemVariantToAdd || '');
    const productList = parseCsvNums(host.dataset.atcItemProductList || '');
    const useAsExclusion = (host.dataset.atcItemUseAsExclusion === 'true');

    if (!enabled || !gifts.length || !(threshold > 0)) return;

    const drawer = getDrawer();

    const shouldRunNow = () => isCartPage() || isDrawerOpen(drawer);

    const syncGift = async (cartMaybe, forceFetch) => {
      if (syncing) return;
      syncing = true;
      try {
        const cart = cartMaybe || await fetchCart(!!forceFetch);

        const hasGift = cart.items.some(i => gifts.includes(i.variant_id));
        const v = viewForRules(cart, gifts);

        let qualifies;
        if (type === 'cart_item_count') qualifies = v.count >= threshold;
        else if (type === 'cart_subtotal') qualifies = v.subtotal >= threshold;
        else qualifies = v.total >= threshold;

        if (violatesProductRule(cart, productList, useAsExclusion)) qualifies = false;

        if (qualifies && !hasGift) {
          await fetch('/cart/add.js', { method: 'POST', headers: headersJson, body: JSON.stringify({ id: gifts[0], quantity: 1 }) });
          const after = await fetchCart(true);
          if (drawer) dispatchTheme(after); else location.reload();
        } else if (!qualifies && hasGift) {
          const updates = {};
          cart.items.forEach(it => { if (gifts.includes(it.variant_id)) updates[it.variant_id] = 0; });
          await fetch('/cart/update.js', { method: 'POST', headers: headersJson, body: JSON.stringify({ updates }) });
          const after = await fetchCart(true);
          if (drawer) dispatchTheme(after); else location.reload();
        }
      } finally {
        syncing = false;
      }
    };

    const safeScheduleSync = (cartMaybe, forceFetch) => {
      if (!shouldRunNow()) return;
      schedule(() => syncGift(cartMaybe, forceFetch).catch(() => {}));
    };

    if (!window.__cond_atc_fetch_patched) {
      window.__cond_atc_fetch_patched = 1;
      const orig = window.fetch;
      window.fetch = function () {
        const args = arguments;
        const req = args[0];
        const url = (typeof req === 'string') ? req : ((req && req.url) || '');
        const p = orig.apply(this, args);
        if (!syncing && /\/cart\/(add|change|update)\.js(\?|$)/.test(url)) {
          p.then(() => setTimeout(() => safeScheduleSync(null, false), 0)).catch(() => {});
        }
        return p;
      };
    }

    document.documentElement.addEventListener('cart:updated', e => safeScheduleSync(e.detail && e.detail.cart, false));
    document.documentElement.addEventListener('cart:refresh', e => safeScheduleSync(e.detail && e.detail.cart, false));

    if (isCartPage()) {
      safeScheduleSync(null, true);
    } else if (drawer) {
      if (isDrawerOpen(drawer)) safeScheduleSync(null, true);
      else {
        const obs = new MutationObserver(() => { if (isDrawerOpen(drawer)) { safeScheduleSync(null, true); obs.disconnect(); } });
        obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'style'] });
      }
    }
  }

  ready(boot);
})();
